<template>
    <nav class="navbar navbar-default navbar-fixed-top no-margin">
        <div class="container-fluid">
            <div class="navbar-header">
                <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar"
                        aria-expanded="false" aria-controls="navbar">
                    <span class="sr-only">Toggle navigation</span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                </button>
                <div class="logo">
                    <a href="#" @click.prevent="goToDashboard"></a>
                </div>
            </div>
            <div id="navbar" class="collapse navbar-collapse">
                <ul class="nav navbar-nav nomobile navbar-back-link">
                    <li v-if="hasAssociatedProvider">
                        <a href="#" @click.prevent="goToProviderDashboard">
                            <i class="fa fa-angle-double-left"></i> {{providerTypeName}} Dashboard
                        </a>
                    </li>
                    <li>
                        <a href="#" @click.prevent="goToDashboard">
                            <i class="fa fa-angle-double-left"></i> Consultant Dashboard
                        </a>
                    </li>
                    <li v-if="memberId" id="top-bar-bread-crumb-link">
                        <a href="#" @click.prevent="goToMemberDashboard(memberId)">
                            <i class="fa fa-angle-double-right"></i>
                            Member Dashboard
                        </a>
                    </li>
                </ul>

                <ul class="nav navbar-nav pull-right">
                    <li>
                        <a href="https://www.accresa.com/resources/consultant" target="_blank"
                           title="Resource Center"><i class="fa fa-lg fa-question-circle"></i></a>
                    </li>
                    <li>
                        <a href="acressa-choose-bs3.html" @click.prevent="logout">
                            <i class="fa fa-unlock-alt"></i> Log out
                        </a>
                    </li>
                </ul>
            </div><!--/.nav-collapse -->
        </div>
    </nav>
</template>

<script>
    import {common} from "../../../global/common.js";
    import {providerUtilities} from "../../../components/shared/providers/utilities.js";
    import {mapGetters} from 'vuex';
    import {api} from "../../../global/framework/api.js";

    export default {
        name: "TopBar",
        props: {
            consultantId: {type: [Number], required: true}
        },
        data() {
            return {
                memberId: null,
            };
        },
        computed: {
            ...mapGetters(["associatedProvider", "associatedProviderConfig", "associatedProviderRole"]),
            hasAssociatedProvider() {
                return this.hasValue(this.associatedProvider);
            },
            providerTypeName() {
                if (!this.hasAssociatedProvider) {
                    return "";
                }
                return this.associatedProviderConfig.name;
            }
        },
        async mounted() {
            let dashboards = await api.getNoId('Account', 'GetAssociatedDashboards');
            let memberDash = dashboards.find(x => x.associatedRoleName == "Consumer");
            this.memberId = memberDash ? memberDash.entityId : null;
            // console.log("mounted memberId:", this.memberId);
        },
        methods: {
            goToDashboard() {
                this.$router.push({name: 'dashboard', params: {consultantId: this.consultantId}});
            },
            goToMemberDashboard(consumerId) {
                window.location.href = `/member/#/${consumerId}/dashboard`;
            },
            goToProviderDashboard() {
                window.location.href = `/${this.associatedProviderRole.toLowerCase()}/#/${this.associatedProvider.providerEntityId}/dashboard`;
            },
            logout() {
                common.logOut();
            }
        }
    }
</script>

<style scoped>

</style>